import React, { useMemo, useState } from "react"
import { motion } from "framer-motion"
import pecuarius_logo from "../../../assets/templates/pecuarius/pecuarius_logo.png"
import profile from "../../../assets/social_icons/profile.png"
import linkedinImg from "../../../assets/social_icons/linkedin.png"
import contact from "../../../assets/social_icons/contact.png"
import email_ from "../../../assets/social_icons/email.png"
import phoneImg from "../../../assets/social_icons/phone.png"
import whatsapp from "../../../assets/social_icons/whatsapp.png"
import facebookp from "../../../assets/social_icons/facebook.png"
import instagramp from "../../../assets/social_icons/instagram.png"
import twitterp from "../../../assets/social_icons/xlogo.png"
import microsoftteamslg from "../../../assets/social_icons/microsoftteams.png"
import videop from "../../../assets/social_icons/video.png"
import power_logo from "../../../assets/social_icons/powerpoint.png"
import word_logo from "../../../assets/social_icons/word.png"
import excel_logo from "../../../assets/social_icons/excel.png"
import pdf_logo from "../../../assets/social_icons/pdf.png"
import ar_logo from "../../../assets/social_icons/ra.png"
import generateVcard from "../../../functions/generateVcard"
import QrModal from "../../../components/QrModal/QrModal"
import { handleProfileImageError, resolveProjectPhoto } from "../../../functions/photoHelpers"

const socialStyle = "flex flex-col md:m-6 md:w-24 sm:m-3 sm:w-3/12 drop-shadow-lg"
const labelStyle = "mt-3 text-center sm:text-sm md:text-base font-body"

const QrIcon = () => (
    <svg width="18" height="18" fill="none" stroke="#fff" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path fill="#fff" stroke="none" d="M19.125 15.75h-3a.375.375 0 0 0-.375.375v3c0 .207.168.375.375.375h3a.375.375 0 0 0 .375-.375v-3a.375.375 0 0 0-.375-.375Z"></path>
        <path fill="#fff" stroke="none" d="M15.375 12.75h-2.25a.375.375 0 0 0-.375.375v2.25c0 .207.168.375.375.375h2.25a.375.375 0 0 0 .375-.375v-2.25a.375.375 0 0 0-.375-.375Z"></path>
        <path fill="#fff" stroke="none" d="M22.125 19.5h-2.25a.375.375 0 0 0-.375.375v2.25c0 .207.168.375.375.375h2.25a.375.375 0 0 0 .375-.375v-2.25a.375.375 0 0 0-.375-.375Z"></path>
        <path fill="#fff" stroke="none" d="M22.125 12.75h-1.5a.375.375 0 0 0-.375.375v1.5c0 .207.168.375.375.375h1.5a.375.375 0 0 0 .375-.375v-1.5a.375.375 0 0 0-.375-.375Z"></path>
        <path fill="#fff" stroke="none" d="M14.625 20.25h-1.5a.375.375 0 0 0-.375.375v1.5c0 .207.168.375.375.375h1.5a.375.375 0 0 0 .375-.375v-1.5a.375.375 0 0 0-.375-.375Z"></path>
        <path fill="#fff" stroke="none" d="M19.125 4.5h-3a.375.375 0 0 0-.375.375v3c0 .207.168.375.375.375h3a.375.375 0 0 0 .375-.375v-3a.375.375 0 0 0-.375-.375Z"></path>
        <path d="M21 2.25h-6.75a.75.75 0 0 0-.75.75v6.75c0 .414.336.75.75.75H21a.75.75 0 0 0 .75-.75V3a.75.75 0 0 0-.75-.75Z"></path>
        <path fill="#fff" stroke="none" d="M7.875 4.5h-3a.375.375 0 0 0-.375.375v3c0 .207.168.375.375.375h3a.375.375 0 0 0 .375-.375v-3a.375.375 0 0 0-.375-.375Z"></path>
        <path d="M9.75 2.25H3a.75.75 0 0 0-.75.75v6.75c0 .414.336.75.75.75h6.75a.75.75 0 0 0 .75-.75V3a.75.75 0 0 0-.75-.75Z"></path>
        <path fill="#fff" stroke="none" d="M7.875 15.75h-3a.375.375 0 0 0-.375.375v3c0 .207.168.375.375.375h3a.375.375 0 0 0 .375-.375v-3a.375.375 0 0 0-.375-.375Z"></path>
        <path d="M9.75 13.5H3a.75.75 0 0 0-.75.75V21c0 .414.336.75.75.75h6.75a.75.75 0 0 0 .75-.75v-6.75a.75.75 0 0 0-.75-.75Z"></path>
    </svg>
)

const SocialLinks = ({ email, phone, linkedin, facebook, instagram, twitter, video, microsoftteams, augmented_reality, word, powerpoint, excel, pdf, animated, typeOfDevice, name, lastname, url }) => (
    <>
        <a className={socialStyle} href={"tel:" + phone}><motion.img
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.9 }}
            transition={{ type: "spring", stiffness: 400, damping: 17 }}
            src={phoneImg} alt="Teléfono" />
            <p className={labelStyle}>Teléfono</p></a>
        <a className={socialStyle + ` ${animated?.whats_animated && 'animate-bounce'} `} href={"https://wa.me/" + phone}><motion.img
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.9 }}
            transition={{ type: "spring", stiffness: 400, damping: 17 }}
            src={whatsapp} alt="Whatsapp" />
            <p className={labelStyle}>WhatsApp</p></a>
        <a className={socialStyle} href={URL.createObjectURL(url)} download={`${String(name + lastname).normalize("NFD").replace(/[\u0300-\u036f]/g, "")}.vcf`}><motion.img
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.9 }}
            transition={{ type: "spring", stiffness: 400, damping: 17 }}
            src={contact} alt="Contacto" />
            <p className={labelStyle}>Contacto</p></a>
        <a className={socialStyle} href={"mailto:" + email}><motion.img
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.9 }}
            transition={{ type: "spring", stiffness: 400, damping: 17 }}
            src={email_} alt="Email" />
            <p className={labelStyle}>Email</p></a>
        {linkedin && <a className={socialStyle} href={linkedin.includes("https://www.linkedin.com/in") ? linkedin : "https://www.linkedin.com/in/" + linkedin}><motion.img
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.9 }}
            transition={{ type: "spring", stiffness: 400, damping: 17 }}
            src={linkedinImg} alt="Linkedin" />
            <p className={labelStyle}>LinkedIn</p></a>}
        {facebook && <a className={socialStyle} href={
            typeOfDevice === "Android" ? (facebook.includes("https://www.facebook.com/") ? `fb://facewebmodal/f?href=${facebook}` : `fb://facewebmodal/f?href=https://www.facebook.com/${facebook}/`) : (
                typeOfDevice === "iOS" ? (facebook.includes("https://www.facebook.com/") ? `fb://profile/${facebook.replace("https://www.facebook.com/", "")}` : `fb://profile/${facebook}`) : (facebook.includes("https://www.facebook.com/") ? `${facebook}` : `https://www.facebook.com/${facebook}/`)
            )
        } >
            <motion.img
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.9 }}
                transition={{ type: "spring", stiffness: 400, damping: 17 }}
                src={facebookp} alt="Facebook" />
            <p className={labelStyle}>Facebook</p></a>}
        {instagram && <a className={socialStyle} href={instagram.includes("https://www.instagram.com/") ? `${instagram}` : `https://instagram.com/${instagram}`} >
            <motion.img
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.9 }}
                transition={{ type: "spring", stiffness: 400, damping: 17 }}
                src={instagramp} alt="Instagram" />
            <p className={labelStyle}>Instagram</p></a>}
        {twitter && <a className={socialStyle} href={twitter.includes("https://twitter.com/") ? `${twitter}` : `https://twitter.com/${twitter}`}>
            <motion.img
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.9 }}
                transition={{ type: "spring", stiffness: 400, damping: 17 }}
                src={twitterp} alt="Twitter" />
            <p className={labelStyle}>X (Twitter)</p></a>}
        {video && <a className={socialStyle} href={`${video}`} target="_blank" rel="noreferrer">
            <motion.img
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.9 }}
                transition={{ type: "spring", stiffness: 400, damping: 17 }}
                src={videop} alt="VIDEO" />
            <p className={labelStyle}>VIDEO</p></a>}
        {microsoftteams &&
            <a className={socialStyle}
                href={microsoftteams.includes("https://teams.microsoft.com/l/") ? microsoftteams : "https://teams.microsoft.com/l/" + microsoftteams}
                target="_blank"
                rel="noreferrer">
                <motion.img
                    whileHover={{ scale: 1.1 }}
                    whileTap={{ scale: 0.9 }}
                    transition={{ type: "spring", stiffness: 400, damping: 17 }}
                    src={microsoftteamslg} alt="Microsoft Teams" />
                <p className={labelStyle}>MS Teams</p>
            </a>
        }
        {augmented_reality &&
            <a className={socialStyle}
                href={augmented_reality}
                target="_blank"
                rel="noreferrer">
                <motion.img
                    whileHover={{ scale: 1.1 }}
                    whileTap={{ scale: 0.9 }}
                    transition={{ type: "spring", stiffness: 400, damping: 17 }}
                    src={ar_logo} alt="Realidad Aumentada" />
                <p className={labelStyle}>RA</p>
            </a>
        }
        {word &&
            <a className={socialStyle}
                href={word}
                target="_blank"
                rel="noreferrer">
                <motion.img
                    whileHover={{ scale: 1.1 }}
                    whileTap={{ scale: 0.9 }}
                    transition={{ type: "spring", stiffness: 400, damping: 17 }}
                    src={word_logo} alt="Word" />
                <p className={labelStyle}>Word</p>
            </a>
        }
        {powerpoint &&
            <a className={socialStyle}
                href={powerpoint}
                target="_blank"
                rel="noreferrer">
                <motion.img
                    whileHover={{ scale: 1.1 }}
                    whileTap={{ scale: 0.9 }}
                    transition={{ type: "spring", stiffness: 400, damping: 17 }}
                    src={power_logo} alt="Power Point" />
                <p className={labelStyle}>Power Point</p>
            </a>
        }
        {excel &&
            <a className={socialStyle}
                href={excel}
                target="_blank"
                rel="noreferrer">
                <motion.img
                    whileHover={{ scale: 1.1 }}
                    whileTap={{ scale: 0.9 }}
                    transition={{ type: "spring", stiffness: 400, damping: 17 }}
                    src={excel_logo} alt="Excel" />
                <p className={labelStyle}>Excel</p>
            </a>
        }
        {pdf &&
            <a className={socialStyle}
                href={pdf}
                target="_blank"
                rel="noreferrer">
                <motion.img
                    whileHover={{ scale: 1.1 }}
                    whileTap={{ scale: 0.9 }}
                    transition={{ type: "spring", stiffness: 400, damping: 17 }}
                    src={pdf_logo} alt="PDF" />
                <p className={labelStyle}>PDF</p>
            </a>
        }
    </>
)

const MainCointainer = ({ user, typeOfDevice, projectLogo }) => {

    const { name, lastname, email, phone, linkedin, photo, facebook, instagram, twitter, web, footer, job, footer_text, typeoffooter, video, animated, linkbuttom, microsoftteams, augmented_reality, excel, powerpoint, pdf, word } = user
    const resolvedPhoto = resolveProjectPhoto({ photo })

    const [showQr, setShowQr] = useState(false)

    const url = useMemo(() => {
        const data = generateVcard(user)
        return data
    }, [user])

    const handleQR = () => {
        setShowQr(!showQr)
    }

    const socialProps = { email, phone, linkedin, facebook, instagram, twitter, video, microsoftteams, augmented_reality, word, powerpoint, excel, pdf, animated, typeOfDevice, name, lastname, url }

    return (
        <main className="flex flex-col">
            <QrModal
                showQr={showQr}
                setShowQr={setShowQr}
                url={window.location.href}
                fullname={`${name} ${lastname}`}
            />

            {/* Escritorio: layout original de dos columnas, sin cambios */}
            <div className="hidden md:flex md:flex-col md:justify-around md:p-20">
                <section className="flex md:justify-start">
                    <div className="md:w-2/5 flex items-center justify-center">
                        <motion.img
                            initial={{ opacity: 0, y: -100 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 1, ease: "easeInOut" }}
                            className="md:scale-100 md:max-w-[400px] max-h-[160px]"
                            src={projectLogo ? projectLogo : pecuarius_logo} alt="logo" />
                    </div>
                </section>
                <section className="flex md:justify-start md:flex-row">
                    <div className="w-full flex justify-center items-center md:flex-col md:w-2/5">
                        <motion.div
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            transition={{ duration: 1, ease: "easeInOut" }}
                            className="flex flex-col items-end justify-center">
                            <img className="md:w-56 md:mt-0 rounded-full mx-auto drop-shadow-lg border-4 border-pecuarius-primary" src={resolvedPhoto ? resolvedPhoto : profile} onError={(event) => handleProfileImageError(event, profile)} alt="profile" />
                            <motion.button
                                onClick={handleQR}
                                title="Ver QR"
                                whileHover={{ scale: 1.1 }}
                                whileTap={{ scale: 0.9 }}
                                style={{ filter: "none" }} className={`flex flex-col items-start justify-center z-10 bg-pecuarius-primary rounded-full p-2 relative ${resolvedPhoto ? '-top-4 left-4' : '-top-6 -left-12'}`}>
                                <QrIcon />
                            </motion.button>
                        </motion.div>
                        <div className="w-full flex flex-col justify-center items-center p-4">
                            <div className="leading-tight mb-4 flex w-full flex-col justify-center items-center">
                                <motion.h1
                                    initial={{ opacity: 0, y: -50 }}
                                    animate={{ opacity: 1, y: 0 }}
                                    transition={{ duration: 1, ease: "easeInOut", delay: 0.8 }}
                                    className="md:text-4xl font-bold text-center font-heading text-pecuarius-primary">{name} {lastname}</motion.h1>
                                {
                                    job &&
                                    <motion.h2
                                        initial={{ opacity: 0, y: -50 }}
                                        animate={{ opacity: 1, y: 0 }}
                                        transition={{ duration: 1, ease: "easeInOut", delay: 1 }}
                                        className="md:text-2xl text-center uppercase font-body text-pecuarius-secondary">{job}</motion.h2>
                                }
                                {web &&
                                    <motion.a
                                        initial={{ opacity: 0, y: -50 }}
                                        animate={{ opacity: 1, y: 0 }}
                                        transition={{ duration: 1, ease: "easeInOut", delay: 1.3 }}
                                        className="md:text-2xl text-center" href={web.includes("https://") ? `${web}` : `https://${web}/`}>
                                        <span className="ml-2 color-texto-web font-body">{web.includes("https://") ? web.replace("https://", "") : web}</span>
                                    </motion.a>
                                }
                                {
                                    projectLogo?.linkbuttom &&
                                    <motion.a
                                        initial={{ opacity: 0, y: -50 }}
                                        animate={{ opacity: 1, y: 0 }}
                                        transition={{ duration: 1, ease: "easeInOut", delay: 1.3 }}
                                        className="px-4 py-4 border-2 border-pecuarius-primary rounded-2xl uppercase mt-4 hover:bg-pecuarius-primary hover:text-white items-center justify-center flex w-[300px]"
                                        href={projectLogo?.linkbuttom?.link}
                                    >
                                        {projectLogo?.linkbuttom?.name}
                                    </motion.a>
                                }
                                {
                                    linkbuttom &&
                                    <motion.a
                                        initial={{ opacity: 0, y: -50 }}
                                        animate={{ opacity: 1, y: 0 }}
                                        transition={{ duration: 1, ease: "easeInOut", delay: 1.6 }}
                                        className="px-4 py-4 border-2 border-pecuarius-primary rounded-2xl uppercase mt-4 hover:bg-pecuarius-primary hover:text-white items-center justify-center flex w-[300px]"
                                        href={linkbuttom?.link}
                                    >
                                        {linkbuttom?.name}
                                    </motion.a>
                                }
                            </div>
                        </div>
                    </div>
                    <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 1, ease: "easeInOut", delay: 1.6 }}
                        className="flex flex-row flex-wrap justify-center items-center p-5 md:w-3/5">
                        <SocialLinks {...socialProps} />
                    </motion.div>
                </section>
            </div>

            {/* Mobile: tarjeta con header de marca, logo arriba a la derecha y medio círculo detrás de la foto */}
            <div className="flex flex-col md:hidden mx-auto max-w-md w-full">
                <div className="relative overflow-hidden h-[380px]">
                    <div className="absolute left-1/2 -translate-x-1/2 -top-[380px] w-[760px] h-[760px]">
                        <motion.div
                            initial={{ opacity: 0, scale: 0.8 }}
                            animate={{ opacity: 1, scale: 1 }}
                            transition={{ duration: 1, ease: "easeInOut" }}
                            className="w-full h-full rounded-full bg-pecuarius-primary">
                        </motion.div>
                    </div>
                    <motion.div
                        initial={{ opacity: 0, y: -20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 1, ease: "easeInOut" }}
                        className="absolute z-10 top-4 right-4 bg-white rounded-lg px-2 py-1 inline-flex">
                        <img className="h-6 w-auto" src={projectLogo ? projectLogo : pecuarius_logo} alt="logo" />
                    </motion.div>
                </div>

                <section className="relative z-10 flex flex-col items-center -mt-[265px] px-5">
                    <div className="relative w-40 h-40 flex items-center justify-center">
                        <div className="absolute inset-0 rounded-full bg-pecuarius-accent"></div>
                        <img
                            className="relative z-10 w-36 h-36 rounded-full border-4 border-white drop-shadow-lg object-cover"
                            src={resolvedPhoto ? resolvedPhoto : profile}
                            onError={(event) => handleProfileImageError(event, profile)}
                            alt="profile" />
                        <motion.button
                            onClick={handleQR}
                            title="Ver QR"
                            whileHover={{ scale: 1.1 }}
                            whileTap={{ scale: 0.9 }}
                            style={{ filter: "none" }} className="flex items-center justify-center z-20 bg-pecuarius-primary rounded-full p-2 absolute bottom-1 right-1 border-2 border-white">
                            <QrIcon />
                        </motion.button>
                    </div>
                    <div className="w-full flex flex-col justify-center items-center mt-3">
                        <div className="leading-tight mb-4 flex w-full flex-col justify-center items-center">
                            <motion.h1
                                initial={{ opacity: 0, y: -50 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ duration: 1, ease: "easeInOut", delay: 0.8 }}
                                className="text-2xl font-bold text-center font-heading text-white">{name} {lastname}</motion.h1>
                            {
                                job &&
                                <motion.h2
                                    initial={{ opacity: 0, y: -50 }}
                                    animate={{ opacity: 1, y: 0 }}
                                    transition={{ duration: 1, ease: "easeInOut", delay: 1 }}
                                    className="text-base text-center uppercase font-body text-white/80">{job}</motion.h2>
                            }
                            {web &&
                                <motion.a
                                    initial={{ opacity: 0, y: -50 }}
                                    animate={{ opacity: 1, y: 0 }}
                                    transition={{ duration: 1, ease: "easeInOut", delay: 1.3 }}
                                    className="text-base text-center" href={web.includes("https://") ? `${web}` : `https://${web}/`}>
                                    <span className="ml-2 color-texto-web font-body">{web.includes("https://") ? web.replace("https://", "") : web}</span>
                                </motion.a>
                            }
                            {
                                projectLogo?.linkbuttom &&
                                <motion.a
                                    initial={{ opacity: 0, y: -50 }}
                                    animate={{ opacity: 1, y: 0 }}
                                    transition={{ duration: 1, ease: "easeInOut", delay: 1.3 }}
                                    className="px-4 py-4 border-2 border-pecuarius-primary rounded-2xl uppercase mt-4 hover:bg-pecuarius-primary hover:text-white items-center justify-center flex w-[300px]"
                                    href={projectLogo?.linkbuttom?.link}
                                >
                                    {projectLogo?.linkbuttom?.name}
                                </motion.a>
                            }
                            {
                                linkbuttom &&
                                <motion.a
                                    initial={{ opacity: 0, y: -50 }}
                                    animate={{ opacity: 1, y: 0 }}
                                    transition={{ duration: 1, ease: "easeInOut", delay: 1.6 }}
                                    className="px-4 py-4 border-2 border-pecuarius-primary rounded-2xl uppercase mt-4 hover:bg-pecuarius-primary hover:text-white items-center justify-center flex w-[300px]"
                                    href={linkbuttom?.link}
                                >
                                    {linkbuttom?.name}
                                </motion.a>
                            }
                        </div>
                    </div>
                    <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 1, ease: "easeInOut", delay: 1.6 }}
                        className="flex flex-row flex-wrap justify-center items-center w-full mt-8">
                        <SocialLinks {...socialProps} />
                    </motion.div>
                </section>
            </div>

            {footer && footer === 'true' ?
                <section className={`${(!footer || footer === 'true') ? 'flex' : 'hidden'} md:justify-end  sm:justify-center md:mt-24 sm:mt-10`}>
                    <motion.span
                        initial={{ opacity: 0, y: -100 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 1, ease: "easeInOut" }}

                        className="md:text-2xl sm:text-lg md:text-right sm:text-center italic">
                        {
                            (footer_text && footer_text !== "" && typeoffooter !== 'defaul' ?
                                footer_text
                                :
                                "Mejoramos las experiencias y fortalecemos las conexiones interpersonales")
                        }
                    </motion.span>
                </section>
                : null}
        </main>
    )
}

export default MainCointainer
